import {
  Batch,
  BatchItemStatus,
  BatchStatus
} from "@wingspanhq/wingspan-api-sdk";
import { queriesBatches } from "@query";
import { useMemo } from "react";

import { selectorFailedImportBatchItemErrors } from "../selectors/selectorFailedImportBatchItemErrors";

type Args = {
  batch: Batch;
  /** `BatchSummary.progress.failed`. */
  failedCount?: number;
};

/** Failed rows of a batch, grouped by the reason they failed. */
export function useFailedBatchItems(args: Args) {
  const batchId = args.batch.id as string;

  const queryAllFailedBatchItems = queriesBatches.listBatchItems.useQueryAll(
    {
      batchId,
      filter: { status: { anyOf: [BatchItemStatus.FAILED] } }
    },
    {
      enabled:
        !!batchId &&
        ((args.failedCount || 0) > 0 ||
          args.batch.status === BatchStatus.FAILED)
    }
  );

  const failedBatchItems = useMemo(
    () =>
      selectorFailedImportBatchItemErrors(
        queryAllFailedBatchItems.flatData ?? []
      ),
    [queryAllFailedBatchItems.flatData]
  );

  return { failedBatchItems, queryAllFailedBatchItems };
}
